import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setCredentialsInfo, cancelCredential } from '../../actions';
import { Link } from 'react-router';
import { v4 } from 'node-uuid';
import PassItem from '../../components/Credentials/PassItem';
import PassItemModal from '../../components/Credentials/PassItemModal';
import {ROUNDS} from '../../constants';
import {CREDENTIAL_TYPE_LABELS} from '../../constants';

class PassesIndex extends Component {

  componentDidMount() {
    this.props.setCredentialsInfo();
  }

  render() {
    const {params:{ type }, credentials, cancelCredential} = this.props;
    const total = credentials.summary[type] ? credentials.summary[type].total : 0;
    const incomplete = credentials.summary[type] ? credentials.summary[type].incomplete : 0;
    const filteredAssignedCredentials = credentials.assignedCredentials.filter(({credentialType}) => credentialType === type);
    const addLink = incomplete === 0 ? "/buy" : `/request-form-${CREDENTIAL_TYPE_LABELS[type]["type_link"]}`;

    return (
      <div className="container">
        <div className="row row-head">
          <Link to="/dashboard" className="pull-left"><div className="icon-white_arrow_back"></div></Link>
          <Link to={addLink} className="btn btn-primary btn-round pulse pull-right">
            <div className="icon-white_add"></div>
          </Link>
          <div className="col-xs-12 col-md-8 col-md-offset-2">
            <h5>{CREDENTIAL_TYPE_LABELS[type]["plural"]}</h5>{incomplete}/{total} Remaining
          </div>
        </div>

        {filteredAssignedCredentials.map(item => {
          const key = v4();
          let name, schedule, trackName;
          if (item.credentialType === 'season') {
            name = "2026 Motoamerica Season";
            schedule = "March 5, 2026 - September 27, 2026";
            trackName = "motoamerica";
          } else {
            let event = ROUNDS.filter((round) => round.id === item.round)[0];
            name = event.name;
            schedule = event.schedule;
            trackName = event.trackName
          }

          return (
            <div key={key}>
              <PassItem
                onClick={() => this.refs[key].showModal()}
                item={item}
              />
              <PassItemModal
                ref={key}
                item={item}
                name={name}
                cancelCredential={cancelCredential}
                schedule={schedule}
                trackName={trackName}
              />
            </div>
          )
        })}



      </div>
    );
  }
}

const mapStateToProps = ({credentials}) => (
  { credentials }
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setCredentialsInfo, cancelCredential }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PassesIndex);



// WEBPACK FOOTER //
// ./src/containers/Passes/index.js